import React from 'react';
import dayjs from 'dayjs';
import {useTranslation} from 'react-i18next';
import ChekinProSettings from '../../ChekinProSettings';
import {device} from 'styled/device';
import {useReservation} from 'context/reservation';
import {useSummary} from 'context/summary';
import {useModalOncePerSession, useScreenResize} from 'hooks';
import {useWhoIsComingModal} from 'components/WhoComingModalSheet';
import {SHOWED_GUEST_GROUP_MODAL} from 'utils/constants';
import editIcon from 'assets/icons/edit-icon.svg';
import * as utc from 'dayjs/plugin/utc';
import {
  BookingStatusItem,
  BookingStatusPanelContainer,
  EditIcon,
  IconContainer,
  Info,
  StyledCustomIcon,
  Title,
} from './styled';

function BookingStatusPanel() {
  const {t} = useTranslation();
  const {data} = useSummary();
  const {data: reservation} = useReservation();
  dayjs.extend(utc.default);
  const check_in_date = data?.check_in_date;
  const check_out_date = data?.check_out_date;
  const expected_guests = data?.expected_guests;
  const {isMatch: isMobileMode} = useScreenResize(device.mobileXL);
  const monthDateFormat = isMobileMode ? 'MMM' : 'MMMM';
  const checkInFormattedDate = dayjs(check_in_date)
    .utc()
    .format(`${monthDateFormat} D, YYYY`);
  const checkOutFormattedDate = dayjs(check_out_date)
    .utc()
    .format(`${monthDateFormat} D, YYYY`);

  const {shouldOpenModal: openWhoIsComingModalPerSession} = useModalOncePerSession({
    id: reservation?.id,
    storageKey: SHOWED_GUEST_GROUP_MODAL,
  });

  const {openModal: openConfirmModal, modal: WhoIsComingModal} = useWhoIsComingModal({
    openModalPerSession: openWhoIsComingModalPerSession,
    showFirstTime: true,
  });

  return (
    <BookingStatusPanelContainer className="booking-status-panel">
      <BookingStatusItem>
        {!isMobileMode && (
          <IconContainer>
            <StyledCustomIcon size={24} name={'checkInCalendar'} color={'  '} />
          </IconContainer>
        )}
        <div>
          <Title>{t('check_in')}</Title>
          <Info>{checkInFormattedDate}</Info>
        </div>
      </BookingStatusItem>
      <BookingStatusItem>
        {!isMobileMode && (
          <IconContainer>
            <StyledCustomIcon size={24} name={'checkOutCalendar'} color={'  '} />
          </IconContainer>
        )}
        <div>
          <Title>{t('check_out')}</Title>
          <Info>{checkOutFormattedDate}</Info>
        </div>
      </BookingStatusItem>
      <BookingStatusItem>
        {!isMobileMode && (
          <IconContainer>
            <StyledCustomIcon size={24} name={'multiGuest'} color={'  '} />
          </IconContainer>
        )}
        <div>
          <Title>{t('guests')}</Title>
          <Info>
            {expected_guests}
            {ChekinProSettings.canEditReservationDetails && (
              <EditIcon src={editIcon} onClick={openConfirmModal} alt="Edit" />
            )}
          </Info>
        </div>
      </BookingStatusItem>
      <WhoIsComingModal />
    </BookingStatusPanelContainer>
  );
}

export {BookingStatusPanel};
